export default __webpack_public_path__ + "static/media/SWT1880.34I-40427_-23937_0.5056b89e.jpg";